import Estimations from "./estimations";
import DomainInput from "./domainInput";
import ParentIdInput from "./parentIdInput";
import DomainToggle from "./domainToggle";
import BooleanToggle from "../../toggle/booleanToggle";
import CircularToggle from "./circularToggle";
import CustomGlobe from "../customglobe/customglobe";
import SelectMap from "../leaflet/selectmap";
import Toggle from "./rotateToggle";
import { regexCenterLat, regexCenterLon, regexPoleLat, regexPoleLon, regexHwidthLat, regexHwidthLon } from "../../../regex/REGEX";

function Icontools({ domainIndex, domains, gridLevel, gridRoot, setIcontoolsField, removeIcontoolsField, colors, twoDView, updateStateField }) {
    const isLocked = domains[0]?.icontools.region_type === 1 && domainIndex === 0;

    return (
        <div className="icontools-options">
            <h2 className="content-title" id="icontools-parameters">ICON Grid Domain {domainIndex + 1}</h2>
            <div className="icontools-content">
                <div className={"content-visualize"}>
                    <BooleanToggle
                        config={{ fieldName: "twoDView" }}
                        left={"2D"}
                        right={"3D"}
                        setStateField={updateStateField}
                        state={twoDView}
                    />
                    {twoDView ?
                        <CustomGlobe
                            className={"domain-globe"}
                            domains={domains}
                            colors={colors}
                            activeDomainIndex={domainIndex}
                        />
                        :
                        <SelectMap
                            domains={domains}
                            colors={colors}
                            activeDomainIndex={domainIndex}
                        />
                    }
                </div>
                <div className="icontools-inputs-container">
                    <Estimations
                        k={gridLevel + 1}
                        n={gridRoot}
                        domainIndex={domainIndex}
                        domains={domains}
                    />
                    <CircularToggle
                        domain={domains[domainIndex]}
                        domainIndex={domainIndex}
                        setIcontoolsField={setIcontoolsField}
                        removeIcontoolsField={removeIcontoolsField}
                    />
                    <ParentIdInput
                        setIcontoolsField={setIcontoolsField}
                        domainIndex={domainIndex}
                        parentId={domains[domainIndex].icontools.parent_id}
                        isLocked={isLocked}
                        domainCount={domains.length}
                    />
                    <DomainInput
                        field={"center_lat"}
                        setIcontoolsField={setIcontoolsField}
                        domainIndex={domainIndex}
                        domains={domains}
                        k={gridLevel + 1}
                        n={gridRoot}
                        regex={regexCenterLat}
                        isLocked={isLocked}
                        tooltipMessage={"The center of the domain in latitude"}
                    />
                    <DomainInput
                        field={"center_lon"}
                        setIcontoolsField={setIcontoolsField}
                        domainIndex={domainIndex}
                        domains={domains}
                        k={gridLevel + 1}
                        n={gridRoot}
                        regex={regexCenterLon}
                        isLocked={isLocked}
                        tooltipMessage={"The center of the domain in longitude"}
                    />
                    {domains[domainIndex].icontools.region_type === 2 ?
                        <DomainInput
                            field={"radius"}
                            setIcontoolsField={setIcontoolsField}
                            domainIndex={domainIndex}
                            domains={domains}
                            k={gridLevel + 1}
                            n={gridRoot}
                            regex={regexHwidthLat}
                            isLocked={isLocked}
                            tooltipMessage={"Radius of the circular domain"}
                        /> :
                        <>
                            <DomainInput
                                field={"hwidth_lat"}
                                setIcontoolsField={setIcontoolsField}
                                domainIndex={domainIndex}
                                domains={domains}
                                k={gridLevel + 1}
                                n={gridRoot}
                                regex={regexHwidthLat}
                                isLocked={isLocked}
                                tooltipMessage={"The half width of the domain in latitude"}
                            />
                            <DomainInput
                                field={"hwidth_lon"}
                                setIcontoolsField={setIcontoolsField}
                                domainIndex={domainIndex}
                                domains={domains}
                                k={gridLevel + 1}
                                n={gridRoot}
                                regex={regexHwidthLon}
                                isLocked={isLocked}
                                tooltipMessage={"The half width of the domain in longitude"}
                            />
                            <Toggle
                                domainIndex={domainIndex}
                                lrotate={domains[domainIndex].icontools.lrotate}
                                setIcontoolsField={setIcontoolsField}
                            />
                            <DomainInput
                                field={"pole_lat"}
                                setIcontoolsField={setIcontoolsField}
                                domainIndex={domainIndex}
                                domains={domains}
                                k={gridLevel + 1}
                                n={gridRoot}
                                regex={regexPoleLat}
                                isLocked={!domains[domainIndex].icontools.lrotate}
                                tooltipMessage={"Pole rotation in latitude<br/><i>Default: 90<i/>"}
                            />
                            <DomainInput
                                field={"pole_lon"}
                                setIcontoolsField={setIcontoolsField}
                                domainIndex={domainIndex}
                                domains={domains}
                                k={gridLevel + 1}
                                n={gridRoot}
                                regex={regexPoleLon}
                                isLocked={!domains[domainIndex].icontools.lrotate}
                                tooltipMessage={"Pole rotation in longitude<br/><i>Default: -180<i/>"}
                            />
                        </>}
                    {domainIndex === 0 &&
                        <DomainToggle
                            basedomain={domains[0]}
                            setIcontoolsField={setIcontoolsField}
                            removeIcontoolsField={removeIcontoolsField}
                        />
                    }
                </div>
            </div>
        </div>

    )
}

export default Icontools;
